import './style.scss';

import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

const blogSlider = new Swiper('.blog-home', {
  slidesPerView: "auto",
  spaceBetween: 24,
  // observer: true,
  // observeParents: true,
  pagination: {
    el: '.blog-home .swiper-pagination',
    clickable: true,
  },

});